import { render, staticRenderFns } from "./PubsList.vue?vue&type=template&id=684db41a&scoped=true&"
import script from "./PubsList.vue?vue&type=script&lang=js&"
export * from "./PubsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684db41a",
  null
  
)

export default component.exports